import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video-player"
export default class extends Controller {
  static targets = ["player", "toggleScrollTo"]
  static outlets = ["video-timecodes"]
  static values = {
    scrollTo: Boolean,
  }

  connect() {
    this.toggleScrollToTarget.checked = this.scrollToValue
  }

  seekTo(timecode) {
    this.playerTarget.currentTime = timecode
  }

  onTimeUpdate() {
    if (!this.hasVideoTimecodesOutlet) return

    this.videoTimecodesOutlet.updateCurrentTime(this.playerTarget.currentTime)
    if (this.scrollToValue) {
      this.videoTimecodesOutlet.scrollTo(this.playerTarget.currentTime)
    }
  }

  toggleScrollTo(event) {
    this.scrollToValue = this.toggleScrollToTarget.checked
  }
}
